// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c0af444","732":"7b8639cf","977":"977e8a3d"}[chunkId] + ".chunk.js";
};